import axios from 'axios';
import 'highcharts-setup';
import 'highcharts-data-label-headroom';
axios.defaults.withCredentials = true;
